import script from "./monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./monitor.vue?vue&type=script&setup=true&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=7692fc28&lang=scss"

const __exports__ = script;

export default __exports__